/**
 * Other Deployment Settings Factories
 *
 * Minimal placeholder factories for deployment types that don't yet have
 * a dedicated typed schema. These return empty settings — configuration
 * happens after creation via their settings views.
 *
 * NOTE: When a typed Zod schema is created for any of these types,
 * delete its entry here and export from the typed schema directly.
 */

// ============================================================
// AIRTABLE
// ============================================================

export const DEFAULT_AIRTABLE_SETTINGS = {};

export function createAirtableDeploymentSettings(): Record<string, unknown> {
  return { ...DEFAULT_AIRTABLE_SETTINGS };
}

// ============================================================
// GOOGLE MEET
// ============================================================

export const DEFAULT_GOOGLE_MEET_SETTINGS = {};

export function createGoogleMeetDeploymentSettings(): Record<string, unknown> {
  return { ...DEFAULT_GOOGLE_MEET_SETTINGS };
}

// ============================================================
// ZOOM
// ============================================================

export const DEFAULT_ZOOM_SETTINGS = {};

export function createZoomDeploymentSettings(): Record<string, unknown> {
  return { ...DEFAULT_ZOOM_SETTINGS };
}
